// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CreateWorkItemRequestModel from '../../model/create-work-item-request-model';
import CreateWorkItemRequestDTO from '../dto/create-work-item-request-dto';
import dtoSchema from '../schemas/create-work-item-request-schema';

export default abstract class CreateWorkItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CreateWorkItemRequestDTO>) {
    super();
    if (data) {
      this.title = data.title ?? undefined;
      this.description = data.description ?? undefined;
      this.workItemType = data.workItemType;
      this.projectId = data.projectId;
    }
  }
  /**
  */
  title?: string;
  /**
  */
  description?: string;
  /**
  * @type {int32}
  */
  workItemType?: 0 | 1 | 2 | 3 | 4; // WorkItemTypeDTO
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<CreateWorkItemRequestDTO>): CreateWorkItemRequestModel;
  static toModel(dto: DeepPartial<CreateWorkItemRequestDTO> | undefined | null): CreateWorkItemRequestModel | undefined;
  static toModel(dto: DeepPartial<CreateWorkItemRequestDTO> | undefined | null): CreateWorkItemRequestModel | undefined {
    return dto ? new CreateWorkItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CreateWorkItemRequestModel> | CreateWorkItemRequestModel): CreateWorkItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      title: unwrapped.title,
      description: unwrapped.description,
      workItemType: unwrapped.workItemType,
      projectId: unwrapped.projectId,
    } as CreateWorkItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CreateWorkItemRequestModel, can not map to CreateWorkItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
